var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gravatar',{staticClass:"avatar",attrs:{"email":_vm.email,"alt":_vm.alt || _vm.email,"default-img":"mm"}})}
var staticRenderFns = []

export { render, staticRenderFns }